import { cn } from '@/lib/cn';

export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex size-9 shrink-0 items-center justify-center rounded-xl bg-violet-deep text-white shadow-sm',
        className,
      )}
    >
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="12" width="4" height="8" rx="1.5" fill="currentColor" opacity="0.55" />
        <rect x="10" y="7" width="4" height="13" rx="1.5" fill="currentColor" opacity="0.8" />
        <rect x="17" y="3" width="4" height="17" rx="1.5" fill="currentColor" />
      </svg>
    </span>
  );
}
